import React, { Component } from "react";
import axios from "axios";
// import HeaderDashboard from "../../part/header.dashaboard";
import FooterDashboard from "../../part/footer.dashboard";
import FilterCourse from "../../part/filter_bar_course";
import DashMenu from "../../part/dash_menu";
import Empty from "../../image/empty.svg"
import { Link } from "react-router-dom";
import Policy from "../../part/policy";
import DashSearchHeader from "../../part/header.search.dashboard";
import { MdArrowDropDown } from "react-icons/md";
import DateDisplay from "../../part/user/dateformate";



class Library extends Component {
    state = {
        menuCoverWidth: this.getInitialMenuCoverWidth(),
        windowHeight: window.innerHeight - 60,
        isActive: false,
        courses: [],
        filter_type_name: "Type",
        filter_level_name: "Level",
        filter_status_name: "Status",
        currentlist: "Enrolled",
        saved_course: [],
        menuwidth: window.innerWidth >= 700,
        isContactVisible: false,
    }
    getInitialMenuCoverWidth() {
        const windowWidth = window.innerWidth;
        if (windowWidth < 900) {
            return 0;
        } else if (windowWidth >= 900 && windowWidth < 1200) {
            return 60;
        } else {
            return 260;
        }
    }



    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.fetchCourses();
        this.fetchSaveCourses();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    fetchCourses = async () => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await axios.get("https://api.geoinfoacademy.com/api/enrolled-courses/", {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            this.setState({ courses: response.data });
            console.log("API Response:", response.data);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                console.warn("401 Unauthorized error detected. Clearing local storage and redirecting.");
                localStorage.removeItem("accessToken");
                localStorage.removeItem("user");
                window.location.href = "/"; 
              } else {
                console.error("Error fetching data:", error);
              }
        }
    };


    fetchSaveCourses = async () => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await axios.get("https://api.geoinfoacademy.com/api/saved-courses/", {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            this.setState({ saved_course: response.data });
            console.log("API Response:", response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
            // Handle errors as needed
        }
    };



    handleResize = () => {
        const menuCover = document.querySelector('.dashboard .menu_cover');
        if (menuCover) {
            this.setState({ menuCoverWidth: menuCover.offsetWidth });
        }
        this.setState({ windowHeight: window.innerHeight - 60 });
        this.setState({ menuwidth: window.innerWidth >= 700 });
    };


    handleRefresh = () => {
        this.setState({
            filter_type_name: "Type",
            selectedItem: "",
            filter_level_name: "Level",
            selectedItems: "",
            filter_status_name: "Status",
            selectedIteme: "",
        }, () => {
            // Important: Call the reset on the child!
            this.filterRef.handleReset(); // Assuming you add a ref to the FilterCourse component
        })
    }

    initialfilterbytype = () => {
        const courses = this.state.courses;
        if (this.state.filter_type_name === "Type" || this.state.filter_type_name === "All") {
            return courses
        } else {
            return courses.filter((item) => item.labels === this.state.filter_type_name);
    
        }
    };
    
    initialfilterbylevel = () => {
        const courses = this.initialfilterbytype();
        
        if (this.state.filter_level_name === "Level" || this.state.filter_level_name === "All") {
            return courses
        }else if (this.state.filter_level_name === "Advance/Professional") {
            return courses.filter(
                (item) =>
                    item.tags === "Advance" ||
                    item.tags === "Professional"
            );
        }else if (this.state.filter_level_name === "Beginner to Advance/Professional") {
            return courses.filter(
                (item) =>
                    item.tags === "Beginner to Advance" ||
                    item.tags === "Beginner to Professional"
            );
        } 
        
         else {
            return courses.filter((item) => item.tags === this.state.filter_level_name);
    
        }
    };
    initialfilterbystatus = () => {
        const courses = this.initialfilterbylevel();
        if (this.state.filter_status_name === "Status" || this.state.filter_status_name === "All") {
            return courses
        } else if (this.state.filter_status_name === "Online") {
            return courses.filter(
                (item) =>
                    item.training_type === "Online Prerecorded" ||
                    item.training_type === "Online Live with Facilitator"
            );
        } 
        // If "Physical" is selected, filter for "general physical class" and "private physical class"
        else if (this.state.filter_status_name === "Physical") {
            return courses.filter(
                (item) =>
                    item.training_type === "General Physical Class" ||
                    item.training_type === "Physical Private Class"
            );
        } 
        // Default case: If filter_level_name matches a specific training_type directly
        else {
            return courses.filter(
                (item) => item.training_type === this.state.filter_status_name
            );
        }
    };
    handleFilterChange = (filterType, filterLevel,filterStatus) => {
        this.setState({
            filter_type_name: filterType,
            filter_level_name: filterLevel,
            filter_status_name: filterStatus,
        })
    };










    initialfilterbytypeSaved = () => {
        const courses = this.state.saved_course;
        if (this.state.filter_type_name === "Type" || this.state.filter_type_name === "All") {
            return courses
        } else {
            return courses.filter((item) => item.labels === this.state.filter_type_name);
    
        }
    
    };

    initialfilterbylevelSaved = () => {
        const courses = this.initialfilterbytypeSaved();
        if (this.state.filter_level_name === "Level" || this.state.filter_level_name === "All") {
            return courses
        }else if (this.state.filter_level_name === "Advance/Professional") {
            return courses.filter(
                (item) =>
                    item.tags === "Advance" ||
                    item.tags === "Professional"
            );
        }else if (this.state.filter_level_name === "Beginner to Advance/Professional") {
            return courses.filter(
                (item) =>
                    item.tags === "Beginner to Advance" ||
                    item.tags === "Beginner to Professional"
            );
        } 
        
         else {
            return courses.filter((item) => item.tags === this.state.filter_level_name);
    
        }
    };
    initialfilterbystatusSaved = () => {
        const courses = this.initialfilterbylevelSaved();
        if (this.state.filter_status_name === "Status" || this.state.filter_status_name === "All") {
            return courses
        } else if (this.state.filter_status_name === "Online") {
            return courses.filter(
                (item) =>
                    item.training_type === "Online Prerecorded" ||
                    item.training_type === "Online Live with Facilitator"
            );
        } 
        // If "Physical" is selected, filter for "general physical class" and "private physical class"
        else if (this.state.filter_status_name === "Physical") {
            return courses.filter(
                (item) =>
                    item.training_type === "General Physical Class" ||
                    item.training_type === "Physical Private Class"
            );
        } 
        // Default case: If filter_level_name matches a specific training_type directly
        else {
            return courses.filter(
                (item) => item.training_type === this.state.filter_status_name
            );
        }
    };


    // enrollfilterData = () => {
    //     const courses = this.initialfilterbylevel();
    //     return courses.filter((item) => item.enrolled === true );
    // };
    handledisplayone = (field) => {
        const divformone = document.querySelector(".library_content.one")
        const divformtwo = document.querySelector(".library_content.two")
        divformone.style.display = "block"
        divformtwo.style.display = "none"
        this.setState({ currentlist: field })
    }
    handledisplaytwo = (field) => {
        const divformone = document.querySelector(".library_content.one")
        const divformtwo = document.querySelector(".library_content.two")
        divformone.style.display = "none"
        divformtwo.style.display = "block"
        this.setState({ currentlist: field })
    }
    handleMenuDropDown = () => {
        const profilemenu = document.querySelector("div.library_menu")
        profilemenu.style.display = profilemenu.style.display === "block" ? "none" : "block";
    }
    render() {
        const { menuCoverWidth, menuwidth } = this.state;
        const enrolleddata = this.initialfilterbystatus()
        function slugify(text) {
            return text
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, '-') // replace non-alphanumeric with -
              .replace(/^-+|-+$/g, '');   // trim dashes
          }
        const SavedData = this.initialfilterbystatusSaved()

        const EnrolledCourses = enrolleddata.length > 0 ? enrolleddata.map((course) => {
            return (
                <Link to={`/description/${course.id}/${slugify(course.title)}`} >
                    <section className="course_library" key={course.id}>
                        <section className="image"><img src={course.thumbnail} alt="course_thumbnail" /></section>
                        <section className="content">
                            <h3>
                                <span> {course.labels} : {course.tags}</span><br />
                                {course.title}
                            </h3>
                            <p>{course.training_type} </p>
                        </section>
                    </section>
                </Link>
            )
        }) : (
            <div className="course_list_empty">
                <img src={Empty} alt="not avaialable" /><br />
                <h5>No Available Course <br />with that specification.</h5>
                <button onClick={this.handleRefresh}>Reset Filter</button>
            </div>
        )


        const SavedCourses = SavedData.length > 0 ? SavedData.map((course) => {
            return (
                <Link to={`/description/${course.id}/${slugify(course.title)}`} >
                    <section className="course_library" key={course.id}>
                        <section className="image"><img src={course.thumbnail} alt="course_thumbnail" />
                        <div className="date_cover"><p><DateDisplay data={course.duration} /></p></div></section>
                        <section className="content">
                            <h3>
                                <span> {course.labels} : {course.tags}</span><br />
                                {course.title}
                            </h3>
                            <p className="details">{course.description}</p>
                            <p>{course.training_type} </p>
                        </section>
                    </section>
                </Link>
            )
        }) : (
            <div className="course_list_empty">
                <img src={Empty} alt="not avaialable" /><br />
                <h5>No Available Course <br />with that specification.</h5>
                <button onClick={this.handleRefresh}>Reset Filter</button>
            </div>
        )

        return (
            <div className="dashboard">
                <DashSearchHeader onResize={this.handleResize} />
                <DashMenu />
                <div className="dash_body" style={{ width: `calc(100% - ${menuCoverWidth}px - 8px)`, overflow:'hidden' }} >
                    <div className="course_head" >
                        <h2> My Library </h2>
                        <FilterCourse
                            filterType={this.state.filter_type_name} // Pass current values as props
                            filterLevel={this.state.filter_level_name}
                            filterStatus={this.state.filter_status_name}
                            onFilterChange={this.handleFilterChange}
                            ref={(el) => this.filterRef = el}
                        />
                    </div>
                    <button className="librarymenu" onClick={this.handleMenuDropDown}>{this.state.currentlist} <MdArrowDropDown /></button>
                    <div className="library_menu" style={{ display: menuwidth ? "block" : "none" }}>
                        <li className={this.state.currentlist === "Enrolled" ? "active" : "none"} onClick={() => { this.handledisplayone("Enrolled") }}>Enrolled</li>
                        <li className={this.state.currentlist === "Saved" ? "active" : "none"} onClick={() => { this.handledisplaytwo("Saved") }}>Saved</li>
                        {/* <li>Saved</li> */}
                    </div>
                    <div className="library_content one" >
                        {EnrolledCourses}
                    </div>
                    <div className="library_content two" >
                        {SavedCourses}
                    </div>
                    <FooterDashboard />
                    <Policy />
                </div>
            </div>
        )
    }
}


export default Library